import * as React from "react";

import { IACSService, IAPIService } from "./services/Service.types";

// Global container for singleton services
export type ServiceContainer = {
  acsService: IACSService;
  apiService: IAPIService;
};

// Create serviceContext to be utilized
export const ServiceContext = React.createContext<ServiceContainer | null>(
  null
);
